import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 1.76 3.87',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M.88,1.05A.49.49,0,0,1,.45.52.48.48,0,0,1,.88,0a.48.48,0,0,1,.43.52A.49.49,0,0,1,.88,1.05Zm0-.93a.37.37,0,0,0-.31.4c0,.23.14.41.31.41s.31-.18.31-.41A.37.37,0,0,0,.88.12Z"
        />
        <path
          fill={fill}
          d="M1.33,2.71a.05.05,0,0,1-.06,0,.05.05,0,0,1,0-.07.53.53,0,0,0,.34-.49V1.84a.53.53,0,0,0-.53-.53H.65a.53.53,0,0,0-.53.53v.27a.53.53,0,0,0,.33.49.06.06,0,0,1,0,.07.06.06,0,0,1-.08,0A.65.65,0,0,1,0,2.11V1.84a.65.65,0,0,1,.65-.65h.46a.65.65,0,0,1,.65.65v.27a.65.65,0,0,1-.41.6Z"
        />
        <path
          fill={fill}
          d="M.88,3.78a.06.06,0,0,1-.06-.06V2.65a.06.06,0,0,1,.06-.06.06.06,0,0,1,.06.06V3.72A.06.06,0,0,1,.88,3.78Z"
        />
        <path
          fill={fill}
          d="M.68,3.87a.45.45,0,0,1-.28-.1.08.08,0,0,1,0,0v-2a.06.06,0,0,1,.06-.06.06.06,0,0,1,.06.06v2a.26.26,0,0,0,.34,0,0,0,0,0,1,.08,0,.24.24,0,0,0,.33,0V1.74a.06.06,0,0,1,.06-.06.06.06,0,0,1,.06.06v2s0,0,0,0a.38.38,0,0,1-.47,0A.35.35,0,0,1,.68,3.87Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
